import { all, takeLatest } from 'redux-saga/effects';

import { sendRetenoAnalytics } from './sendRetenoAnalytics';
import * as actionTypes from '../actionTypes';

export default function* watchAnalytics() {
    yield all([takeLatest(actionTypes.SEND_RETENO_ANALYTICS_REQUEST, sendRetenoAnalytics)]);
}
